import React, { useEffect, useState } from 'react'
import { IonButton } from '@ionic/react'
import { GuruSlider, GuruSlide} from '../../components';
import { ifExistAndMayorToZero } from '../../utils/arrays';
import './WordsSlider.scss'
import { eventWithName } from '../../pages/firebase/firebaseTags';

interface Props {
  words:any[]
  getVendorsWithOffers?: any
  whenUpdateOffers?: any
  isLoading?: any
  isLoadingProducts?:boolean
  fireEvent?: string
  subcategoryId?: string;
}

const slideOpts = {
  autoHeigth: true,
  spaceBetween: 10,
  slidesPerView: 'auto',
  observer: true,
  observeParents: true
};

const WordsSlider: React.FC<Props> = props => {
  const { words, getVendorsWithOffers, whenUpdateOffers, isLoading, isLoadingProducts} = props
  const IsIfHasPropertyFrom = words[0]?.from ? {} : words[0]
  const [isSelected, setIsSelected] = useState<any>(IsIfHasPropertyFrom)
  const [isFetching, setIsFetching] = useState<boolean>(false)

  useEffect(() => {
    setIsSelected(IsIfHasPropertyFrom)
    if(isSelected) setIsFetching(true)
  }, [!isFetching]) 

  useEffect(() => {
    if (!isFetching) {
      setSubcategoryFromDeeplink()
    }
  // eslint-disable-next-line 
  }, [!isFetching]);

  const setSubcategoryFromDeeplink = () => {
    if (props.subcategoryId) {
      setTimeout(() => {
        const word = props.words.find(item => item._id === props.subcategoryId);
        if (word) onClickWord(word);
      }, 500)
    }
  }

  const onClickWord = async (word:any) => {
    if (word.from && getVendorsWithOffers && whenUpdateOffers && isLoading) {
      whenUpdateOffers()
      isLoading(true)
      if(!compareIsIfEqualWord(word._id)) {
        setIsSelected(word)
        await getVendorsWithOffers(word._id, word.name)
      } else {
        setIsSelected({})
        await getVendorsWithOffers()
      }
    } else {
      if (isSelected.name !== word.name && props.fireEvent) {
        eventWithName(props.fireEvent, {
          value: word.name
        })
      }
      setIsSelected(word)
      const wordId = word._id.length > 14 ? word._id : words[1]?._id
      const section = document.querySelector(`div[id *="${wordId}"]:not([id *="slide-"])`);
      section?.scrollIntoView({behavior:'smooth'});
    }
  }
  
  const slideWords = () => {
    return (
      words.map((word: any, index:number) => 
        {
          const STYLE_SLIDE = `${index === 0 ? 'isFirst' : ''} ${isSelected._id === word._id ? 'selected' : 'not-selected'} ${words.length - 1 === index ? 'last-word' : ''}`
          const IfISOffer = `${words[0].name === 'Ofertas' && isSelected._id === 'offers' ? 'tab-offer' : ''}`

          return (
            <GuruSlide 
              key={index.toString() + word._id}
              className={`swiper-slide-word ${STYLE_SLIDE} ${IfISOffer}`}
              onClick={() => onClickWord(word)}
              id={`slide-${word._id}`}      
            >
              <IonButton
                shape="round"
                id={`button-${word._id}`}
                disabled={isLoadingProducts}
                className={`word-slide ${STYLE_SLIDE} ${IfISOffer}`}
                fill="clear"
                       
              >
                {word.name}
              </IonButton>
            </GuruSlide>
          )
        }
      )
    )
  }

  const compareIsIfEqualWord = (wordId:string) => isSelected._id === wordId

    return (
      <div className="container-slider">
        {isFetching && ifExistAndMayorToZero(words) && 
          <GuruSlider 
            className="swiper-container" 
            autoHeight={false}
            spaceBetween={10}
            slidesPerView={2.5}
            observer={true}
            observeParents={true}
          >
            {slideWords()} 
          </GuruSlider>
        }
      </div>
    )
  }

export default WordsSlider